import { MoreOutlined } from "@ant-design/icons";
import { Button, Card, Carousel, Dropdown, Image, Tag } from "antd";
import {
  AmountIcon,
  PenIcon,
  PlusIcon,
  SearchIcon,
  StarFilledIcon,
} from "../../../../../../atoms/CustomIcons";

export default function ProfileSidebar() {
  const items = [
    {
      key: "1",
      label: (
        <Button type="text" className="no-hover">
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button type="text" className="delete-hover">
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      <Card className="profileSidebar">
        <div className="contactCarousel">
          <div className="carouselHeading"> Contacts </div>

          <Carousel arrows infinite={false} dots={false}>
            <div className="carouselWrapper">
              <div className="carouselTop">
                <div className="leftCarousel">
                  <h5>Laura Benton</h5>
                  <Tag className="purple_tag">Operations Coordinator</Tag>
                </div>
                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="actionButton"
                >
                  <Button
                    style={{ padding: "6px" }}
                    className="only_icon btn-sm"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div>

              <div className="carouselContent">
                <div className="contentWrapper">
                  <div className="leftWrapper">Phone:</div>
                  <div className="rightWrapper">+1 (555) 234-1182</div>
                </div>
                <div className="contentWrapper">
                  <div className="leftWrapper">Email:</div>
                  <div className="rightWrapper">laura.benton@greenedg...</div>
                </div>
                <div className="contentWrapper">
                  <div className="leftWrapper">Roles:</div>
                  <div className="rightWrapper">
                    <div className="profileActionBtns">
                      <Button type="text" className="activeIcon">
                        <StarFilledIcon />
                      </Button>
                      <Button type="text" className="notActiveIcon">
                        <PenIcon />
                      </Button>
                      <Button type="text" className="activeIcon">
                        <AmountIcon />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="carouselWrapper">
              <div className="carouselTop">
                <div className="leftCarousel">
                  <h5>John Smith</h5>
                  <Tag className="yellow_tag">Property Manager</Tag>
                </div>
                <Dropdown
                  menu={{ items }}
                  trigger={["click"]}
                  placement="bottomRight"
                  className="actionButton"
                >
                  <Button
                    style={{ padding: "6px" }}
                    className="only_icon btn-sm"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              </div>

              <div className="carouselContent">
                <div className="contentWrapper">
                  <div className="leftWrapper">Phone:</div>
                  <div className="rightWrapper">(987) 654-3210</div>
                </div>
                <div className="contentWrapper">
                  <div className="leftWrapper">Email:</div>
                  <div className="rightWrapper">john.smith@example.com</div>
                </div>
                <div className="contentWrapper">
                  <div className="leftWrapper">Roles:</div>
                  <div className="rightWrapper">
                    <div className="profileActionBtns">
                      <Button type="text" className="notActiveIcon">
                        <StarFilledIcon />
                      </Button>
                      <Button type="text" className="activeIcon">
                        <PenIcon />
                      </Button>
                      <Button type="text" className="notActiveIcon">
                        <AmountIcon />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
      </Card>

      <Card
        className="profileSidebar"
        onClick={() =>
          window.open(
            "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2985-233871&p=f&viewport=3230%2C3079%2C0.31&t=BgbjHvEjnw9ohjvG-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2985%3A233871",
            "_blank"
          )
        }
        style={{ marginTop: "8px", cursor: "pointer" }}
      >
        <div className="documentHeader">
          <h4>Documents</h4>

          <Button className="btn-sm" icon={<PlusIcon />} />
          <Button className="btn-sm" icon={<SearchIcon />} />
        </div>

        <div className="documentListWrapper">
          <Card className="documentList inner_card doc_extra_card">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>Legal</span>
            </div>
            <div className="documentImage">
              <Image
                src="/images/dummy/doc_img_sample.png"
                preview={false}
                width={"100%"}
              />
            </div>
          </Card>
        </div>
      </Card>
    </>
  );
}
